export const immutableObject =  (prototype,descriptor) => Object.freeze(Object.create(prototype,descriptor));

export default immutableObject;



